/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tour_References_TitleInputs */

const en_wc_tour_references_title = /** @type {(inputs: Wc_Tour_References_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`References`)
};

/**
* | output |
* | --- |
* | "References" |
*
* @param {Wc_Tour_References_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tour_references_title = /** @type {((inputs?: Wc_Tour_References_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tour_References_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tour_references_title(inputs)
});
export { wc_tour_references_title as "wc.tour.references.title" }